import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import type { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export type OfferRequestContactScreenProps = {
    onBack: () => void;
    children: ReactNode;
};

// Covers the app bar rather than asking the layout to hide it: the design gives the phone's whole
// viewport to the conversation, and a fixed layer keeps that decision inside this feature.
export function OfferRequestContactScreen({ onBack, children }: OfferRequestContactScreenProps): ReactElement {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                position: 'fixed',
                inset: 0,
                zIndex: (theme) => theme.zIndex.appBar + 1,
                display: 'flex',
                flexDirection: 'column',
                bgcolor: 'background.paper',
            }}>
            <Box sx={{ flexShrink: 0, px: 2 }}>
                <IconButton onClick={onBack} aria-label={t('OFFER_REQUESTS.DETAIL.BACK')}>
                    <ArrowBackIcon />
                </IconButton>
            </Box>
            {children}
        </Box>
    );
}
